/*
 * Application Insights JavaScript SDK - Common, 2.8.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

import { dataSanitizeId, dataSanitizeMeasurements, dataSanitizeProperties, dataSanitizeString, dataSanitizeUrl } from "./Common/DataSanitizer";
import { msToTimeSpan } from "../HelperFuncs";
import { strNotSpecified } from "../Constants";
var PageView = /** @class */function () {
  /**
   * Constructs a new instance of the PageEventTelemetry object
   */
  function PageView(logger, name, url, durationMs, properties, measurements, id) {
    this.aiDataContract = {
      ver: 1 /* FieldType.Required */,
      name: 0 /* FieldType.Default */,
      url: 0 /* FieldType.Default */,
      duration: 0 /* FieldType.Default */,
      properties: 0 /* FieldType.Default */,
      measurements: 0 /* FieldType.Default */,
      id: 0 /* FieldType.Default */
    };
    var _self = this;
    _self.ver = 2;
    _self.id = dataSanitizeId(logger, id);
    _self.url = dataSanitizeUrl(logger, url);
    _self.name = dataSanitizeString(logger, name) || strNotSpecified;
    if (!isNaN(durationMs)) {
      _self.duration = msToTimeSpan(durationMs);
    }
    _self.properties = dataSanitizeProperties(logger, properties);
    _self.measurements = dataSanitizeMeasurements(logger, measurements);
  }
  PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
  PageView.dataType = "PageviewData";
  return PageView;
}();
export { PageView };